import { Link } from "@inertiajs/react";
import { useRef, useState, useEffect } from "react";
import { HomeSectionLayout } from "../../../../../components/HomeSectionLayout";
import { FeaturedContentItem } from "../index";
import RichMarkdownContent from "../../../../Announcements/RichMarkdownContent";
import { BreadCrumbs } from "../../../../../components/BreadCrumbs";
import { SECTION_COLORS } from "../../../../../utils/colors";

interface ReferenceItem extends FeaturedContentItem {
  title: string;
  content: string;
  section_title?: string;
}

const MAX_HEIGHT = 600;

export default function ReferenceSection({ item, index }: { item: FeaturedContentItem; index: number }) {
  const reference = item as ReferenceItem;
  const colors = SECTION_COLORS[index % SECTION_COLORS.length];
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (contentRef.current) {
      setIsOverflowing(contentRef.current.scrollHeight > MAX_HEIGHT);
    }
  }, [reference.content]);

  return (
    <HomeSectionLayout.Container style={{
      backgroundColor: colors.bg,
      color: colors.text
    }}>
      <div style={{
        width: '100%'
      }}>
        <HomeSectionLayout.HeaderDescription>
          <BreadCrumbs.Container>
            <BreadCrumbs.LinkItem href="/reference">
              Reference
            </BreadCrumbs.LinkItem>
            <BreadCrumbs.TextItem>
              {reference.section_title}
            </BreadCrumbs.TextItem>
          </BreadCrumbs.Container>
        </HomeSectionLayout.HeaderDescription>
        <HomeSectionLayout.Header>
          {reference.title}
        </HomeSectionLayout.Header>
      </div>
      <HomeSectionLayout.Content style={{
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '20px',
          width: '100%'
        }}>
          <div style={{
            flex: 1,
            width: '100%',
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: '10px',
            flexShrink: 0
          }}>
            <div style={{
              position: 'relative',
              maxHeight: isOverflowing ? MAX_HEIGHT : undefined,
              overflow: isOverflowing ? 'hidden' : undefined,
            }}>
              <div
                ref={contentRef}
                style={{
                  fontSize: '1.1rem',
                  lineHeight: '1.8',
                  textAlign: 'justify',
                  width: '100%',
                }}
              >
                <RichMarkdownContent>
                  {reference.content}
                </RichMarkdownContent>
              </div>
              {isOverflowing && (
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '80px',
                  background: `linear-gradient(to bottom, transparent, ${colors.bg})`,
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'center',
                  paddingBottom: '10px',
                }}>
                  <Link
                    href={`/references/${reference.id}`}
                    className="btn btn-light btn-sm"
                    style={{
                      padding: '8px 24px',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      textDecoration: 'none',
                    }}
                  >
                    Read More
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </HomeSectionLayout.Content>
    </HomeSectionLayout.Container>
  )
}
